





































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Xkz extends Vue {
    @Prop({ type: [Number, String] })
    year!: number;

    form = {
        accountBookId: this.$store.state.accountBook.id,
        year: this.year,
        fromDate: "",
        toDate: "",
        name: "",
        no: "",

    }
    dataList:any = []
    mounted() {
        this.fetchData();
    }
    async addData() {
        const keys = Object.keys(this.form);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            // @ts-ignore
            if ((this.form[key] === null || this.form[key] === "") && key !== "id" && key !== "gmtCreate"&& key !== "gmtModified"  ) {
                console.log(key)
                this.$notify({
                    title: "温馨提示",
                    message: "请将所有信息填写完整",
                    type: "warning"
                });
                return;
            }

        }
        await Vue.axios.post(`gsnb/czdwxkz/save`, this.form);
        this.fetchData()
        this.$emit("update", this.form);
        this.form = {
            accountBookId: this.$store.state.accountBook.id,
            year: this.year,
            fromDate: "",
            toDate: "",
            name: "",
            no: "",

        }
    }
    // async save() {
    //     const keys = Object.keys(this.form);
    //     for (let i = 0; i < keys.length; i++) {
    //         const key = keys[i];
    //         // @ts-ignore
    //         if ((this.form[key] === null || this.form[key] === "") && key !== "id" && key !== "gmtCreate"&& key !== "gmtModified"  ) {
    //             console.log(key)
    //             this.$notify({
    //                 title: "温馨提示",
    //                 message: "请将所有信息填写完整",
    //                 type: "warning"
    //             });
    //             return;
    //         }

    //     }
    //     await Vue.axios.post(`gsnb/czdwxkz/save`, this.form);
    //     this.fetchData()
    //     this.form = {
    //         accountBookId: this.$store.state.accountBook.id,
    //         year: this.year,
    //         fromDate: "",
    //         toDate: "",
    //         name: "",
    //         no: "",

    //     }
    // }
    async saveData(data:any) {
        const keys = Object.keys(data);
        console.log(data)
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            // @ts-ignore
            if ((data[key] === null || data[key] === "") && key !== "id" && key !== "gmtCreate"&& key !== "gmtModified"  ) {
                console.log(key)
                this.$notify({
                    title: "温馨提示",
                    message: "请将所有信息填写完整",
                    type: "warning"
                });
                return;
            }

        }
        await Vue.axios.post(`gsnb/czdwxkz/update`, data);
        this.fetchData()
        this.$emit("update", this.form);
    }
    async fetchData() {
        const res = await Vue.axios.get(`gsnb/czdwxkz/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        console.log(res)
        if (res.data.data) {
            console.log(res.data)
            this.dataList = res.data.data
        }
    }
    async deleteItem(id:number) {
        this.$confirm("亲，此操作将删除该行, 是否继续?", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(async () => {
            const res = await Vue.axios.delete(`gsnb/czdwxkz/delete?id=${id}&year=${this.year}&accountBookId=${this.$store.state.accountBook.id}`)
            if(res) {
                this.fetchData()
                this.$emit("update", this.form);
            }
        }).catch(() => {
        });
    }

}
